const contacts = state => state.contacts
const contact = state => state.contact

export default {
  contacts,
  contact
};
